(function ($, debounce) {
  'use strict';

  $(document).ready(() => {

    $(".paragraph--type--gallery .link").on("click", debounce((element) => {
      $(element.currentTarget).parent().find("a.photoswipe")[0].click();
    }, 50));

  });

})(jQuery, Drupal.debounce);
